var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.66667 14C9.57912 14.3174 9.42992 14.6144 9.22759 14.8741C9.02525 15.1338 8.77375 15.3511 8.48744 15.5136C8.20112 15.6761 7.88561 15.7806 7.5589 15.8212C7.23219 15.8617 6.90069 15.8375 6.58333 15.75C6.26597 15.6625 5.96896 15.5133 5.70926 15.3109C5.44956 15.1086 5.23226 14.8571 5.06975 14.5708C4.90725 14.2845 4.80273 13.9689 4.76217 13.6422C4.7216 13.3155 4.74579 12.984 4.83333 12.6667M2.5 9.16667L17.5 5V15L2.5 11.6667V9.16667Z",
    stroke: "currentColor",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.581f6704906543945eaa24560ae0f17f.svg";
export { ForwardRef as ReactComponent };